/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_New_CompanyInputs */

const cs_settings_venues_new_company = /** @type {(inputs: Settings_Venues_New_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová firma`)
};

const en_settings_venues_new_company = /** @type {(inputs: Settings_Venues_New_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New company`)
};

/**
* | output |
* | --- |
* | "New company" |
*
* @param {Settings_Venues_New_CompanyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_new_company = /** @type {((inputs?: Settings_Venues_New_CompanyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_New_CompanyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_new_company(inputs)
	return cs_settings_venues_new_company(inputs)
});